import { render, staticRenderFns } from "./ops_desk_settings.vue?vue&type=template&id=0a796d0d&scoped=true&"
import script from "./ops_desk_settings.vue?vue&type=script&lang=js&"
export * from "./ops_desk_settings.vue?vue&type=script&lang=js&"
import style0 from "./ops_desk_settings.vue?vue&type=style&index=0&id=0a796d0d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a796d0d",
  null
  
)

export default component.exports